import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Group, Text, Button } from '@mantine/core';
import PlantCard from './PlantCard';
import omitButton from '../images/ui_buttons/omit_button.png';
import { useAppContext } from '../context/AppContext';
import { colors, fontSize } from '../constants';

const IMAGE_URL = import.meta.env.VITE_S3_PNG_URL;

const PlantListMobile = ({ plants, selectedPlantId, currentPlantCategory, onSelect }) => {
  const listContainerRef = useRef(null);
  const { state } = useAppContext();
  const { hasActiveSubscription, subscribedPlan } = state.user;

  useEffect(() => {
    const listContainer = listContainerRef.current;

    const handleWheel = (event) => {
      if (event.deltaY !== 0) {
        listContainer.scrollLeft += event.deltaY;
        event.preventDefault();
      }
    };

    listContainer.addEventListener('wheel', handleWheel, {
      passive: false,
    });

    return () => {
      listContainer.removeEventListener('wheel', handleWheel);
    };
  }, []);

  const handleOmitSelect = () => {
    onSelect(null, currentPlantCategory);
  };

  return (
    <Box style={{
      backgroundColor: colors.backgroundLight,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      overflow: 'hidden',
      height: '14vh'
    }}>
      {/* Plant List Container */}
      <Box 
        ref={listContainerRef}
        style={{
          display: 'flex',
          flexDirection: 'row', 
          gap: '1.5vw',
          alignItems: 'center',
          overflowX: 'auto',
          overflowY: 'hidden',
          whiteSpace: 'nowrap',
          padding: '1vw',
          scrollbarWidth: 'thin',
          flex: 1,
          height: '100%'
        }}
      >
        {/* "Omit" Plant Card */}
        <Box style={{ height: '100%' }}>
          <PlantCard
            plant={{ Common: 'Omit' }}
            image={omitButton}
            isSelected={selectedPlantId === null}
            onSelect={handleOmitSelect}
            shouldDisplayText={true}
            isMobile={true}
          />
        </Box>
        
        {/* Normal Plant Cards */}
        {plants.map((plant) => (
          <Box key={plant.ID} style={{ height: '100%' }}>
            <PlantCard
              plant={plant}
              image={`${IMAGE_URL}/${plant.ImageURL}.png`}
              isSelected={plant.ID === selectedPlantId}
              onSelect={() => onSelect(plant.ID, plant.Category)}
              shouldDisplayText={hasActiveSubscription}
              subscribedPlan={subscribedPlan}
              isMobile={true}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

PlantListMobile.propTypes = {
  plants: PropTypes.arrayOf(
    PropTypes.shape({
      ID: PropTypes.string.isRequired,
      Common: PropTypes.string.isRequired,
      Category: PropTypes.string.isRequired,
      ImageURL: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedPlantId: PropTypes.string,
  currentPlantCategory: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default PlantListMobile;
